import styled from 'styled-components'

// the design draws the X off the centre of its circle
const Svg = styled.svg`
  transform: translate(-0.26px, 0.17px);
`

export const CloseIcon = () => (
  <Svg
    width='13.94'
    height='13.94'
    viewBox='0 0 13.94 13.94'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
  >
    <path
      d='M13.09 13.09L6.97 6.97M6.97 6.97L0.85 0.85M6.97 6.97L13.09 0.85M6.97 6.97L0.85 13.09'
      stroke='white'
      strokeWidth='1.7'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </Svg>
)
